module.exports = __webpack_public_path__ + "static/media/whurdle.5946bd12.mov";